import React, {useState, useEffect} from 'react';
import {withRouter} from "react-router-dom";
import {withToastManager} from "react-toast-notifications";
import {connect} from "react-redux";
import {saveUserActivationData} from "../../../../../slices/userSlice";
import LoadingIndicator from "../../../../meta/LoadingIndicator";
import AuthenticationService from "../../../../../services/Authentication/AuthenticationService";
import TermsAndPrivacyModal from "../../../modals/TermsAndPrivacyModal";
import jwt_decode from "jwt-decode";

function GoogleAuthComponent(props) {
    const {toastManager, history} = props;

    const [ state, setState ] = useState( {googleJwt: props.location.state.googleJwt, loading: true, modalShown: false, userId: null, alreadyRegistered: false});

    useEffect(() => {
        handleGoogleAuthentication();
    }, []);

    function closeAgreementModal() {
        setState({...state, modalShown: false});
        history.goBack();
    }

    function handleGoogleAuthentication() {
        AuthenticationService.defaultLogin(null, null, null, state.googleJwt,
            (response) => {
                if (response.data.user_agrees_contact) {
                    props.saveUserActivationData(response.data.user_id, response.data.token, response.data.level);
                    history.push("/surveys");
                }
                else {
                    setState({...state, alreadyRegistered: true, userId: response.data.user_id, modalShown: true});
                }
            },
            (error) => {
                if (error.data.code && error.data.code === window.bubblyWebsiteConfig.CODE_USER_NON_EXISTENT) {
                    setState({...state, alreadyRegistered: false, modalShown: true});
                }
                else if (error.data.code && error.data.code === window.bubblyWebsiteConfig.CODE_USER_NOT_ACTIVE) {
                    //showLoginErrorMessageBasedOnErrorCode(error.data.code);
                    AuthenticationService.goBackAfterTimeout(history);
                }
                else {
                    toastManager.add("Error occurred while trying to login user using Google!", {
                        appearance: 'error'
                    });
                    AuthenticationService.goBackAfterTimeout(history);
                }
            }
        );
    }

    function handleGoogleRegistration() {
        const {alreadyRegistered, googleJwt} = state;
        const googleUser = jwt_decode(googleJwt);

        if (!googleUser.email) {
            toastManager.add("Error with Google register, no email address received from Google!", {
                appearance: 'error'
            });
            AuthenticationService.goBackAfterTimeout(history);
        }

        const googleResponse = {
            email: googleUser.email,
            first_name: googleUser.given_name,
            last_name: googleUser.family_name,
            accessToken: googleJwt
        };

        const userData = {
            user_agreement: true,
            user_agrees_contact: true
        };

        AuthenticationService.decideGoogleRegistration(googleResponse, alreadyRegistered, userData,
            (response) => {
                props.saveUserActivationData(response.data.user_id, response.data.token, response.data.level);
                history.push('/surveys');
            },
            (error) => {
                toastManager.add("Error occurred while trying to register user using Google!", {
                    appearance: 'error'
                });
                AuthenticationService.goBackAfterTimeout(history);
            }
        );
    };

    return (
        <section className="confirm-account">
            <div className="container">
                <TermsAndPrivacyModal modalShown={state.modalShown} closeModal={closeAgreementModal} agreementConfirmFunction={handleGoogleRegistration}/>
                <h2 className="pt-xlg pb-xl">Google Login...</h2>
                {
                    state.loading && <LoadingIndicator/>
                }
            </div>
        </section>
    );
}

const mapDispatchToProps = {saveUserActivationData};

export default connect(null, mapDispatchToProps)(withRouter(withToastManager(GoogleAuthComponent)));